// src/BlogPost.jsx
import { useEffect } from "react";
import { getPostBySlug } from "./blogPosts";

const BlogPost = ({ slug, onBack, onBlogIndex, onStartChat }) => {
  const post = getPostBySlug(slug);

  useEffect(() => {
    if (!post) return;
    const prevTitle = document.title;
    const prevDesc = document.querySelector('meta[name="description"]')?.getAttribute("content");

    document.title = `${post.title} | Ask Irene`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", post.excerpt);

    return () => {
      document.title = prevTitle;
      if (meta && prevDesc) meta.setAttribute("content", prevDesc);
    };
  }, [post]);

  if (!post) {
    return (
      <section style={{
        padding: "clamp(64px, 10vh, 120px) 24px 80px",
        maxWidth: "720px", margin: "0 auto", textAlign: "center",
      }}>
        <p style={{ fontFamily: "'DM Serif Display', serif", fontSize: "24px", color: "var(--ink)", marginBottom: "16px" }}>
          Post not found
        </p>
        <button
          onClick={onBlogIndex}
          style={{
            background: "none", border: "none", cursor: "pointer",
            fontSize: "14px", color: "var(--accent)", fontFamily: "inherit",
          }}
        >
          &larr; Back to blog
        </button>
      </section>
    );
  }

  const Content = post.content;

  return (
    <article style={{
      padding: "clamp(64px, 10vh, 120px) 24px 80px",
      maxWidth: "720px", margin: "0 auto",
    }}>
      <button
        onClick={onBlogIndex}
        aria-label="Back to blog"
        style={{
          background: "none", border: "none", cursor: "pointer",
          fontSize: "14px", color: "var(--ink-muted)", fontFamily: "inherit",
          marginBottom: "32px", padding: 0,
        }}
        onMouseEnter={(e) => (e.target.style.color = "var(--ink)")}
        onMouseLeave={(e) => (e.target.style.color = "var(--ink-muted)")}
      >
        &larr; All posts
      </button>

      <p style={{
        fontSize: "13px", color: "var(--ink-muted)",
        marginBottom: "14px", letterSpacing: "0.02em",
      }}>
        {post.date}
      </p>

      <h1 style={{
        fontFamily: "'DM Serif Display', serif",
        fontSize: "clamp(26px, 4vw, 38px)", fontWeight: "400",
        color: "var(--ink)", letterSpacing: "-0.02em",
        lineHeight: 1.2, marginBottom: "40px", maxWidth: "640px",
      }}>
        {post.title}
      </h1>

      <div className="prose">
        <Content />
      </div>

      {/* CTA */}
      <div style={{
        marginTop: "56px",
        backgroundColor: "var(--accent-mist)",
        border: "1px solid var(--accent)",
        borderRadius: "12px",
        padding: "32px",
      }}>
        <p style={{
          fontFamily: "'DM Serif Display', serif",
          fontSize: "22px", fontWeight: "400", color: "var(--ink)",
          marginBottom: "10px", lineHeight: 1.3,
        }}>
          Ready to take action on your bills?
        </p>
        <p style={{
          fontSize: "15px", color: "var(--ink-soft)",
          lineHeight: 1.7, marginBottom: "20px",
        }}>
          Talk to Irene — she can walk you through your specific situation, help you find
          local resources, and give you a clear next step. It's free.
        </p>
        <button
          onClick={onStartChat}
          style={{
            padding: "12px 24px", fontSize: "14px", fontWeight: "600",
            backgroundColor: "var(--accent)", color: "#fff",
            border: "none", borderRadius: "8px", cursor: "pointer",
            fontFamily: "inherit", transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--accent-light)")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--accent)")}
        >
          Talk to Irene — it's free
        </button>
      </div>
    </article>
  );
};

export default BlogPost;
